import Header from '@8x8/oxygen-modal-header'
import React from 'react'
import styled from 'styled-components'

const StyledModalHeader = styled(Header)`
  & > div {
    white-space: normal;
    word-break: break-word;
  }
`

const ModalHeader = props =>
  <StyledModalHeader {...props} />

export default ModalHeader
